import React from "react";
import { ShieldCheck } from "lucide-react";

export const Logo = ({ className = "", showText = true, dark = false }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground shadow-sm">
        <ShieldCheck className="h-5 w-5" />
      </div>
      {showText && (
        <div className="leading-tight">
          <span className={`font-display text-[15px] font-semibold ${dark ? "text-white" : "text-foreground"}`}>
            HostGuard
          </span>
          <span className={`block text-[10px] font-medium uppercase tracking-wider ${dark ? "text-white/60" : "text-muted-foreground"}`}>
            Australia
          </span>
        </div>
      )}
    </div>
  );
};
